var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "5 5 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.91 10.818a2.91 2.91 0 1 1-5.82 0 2.91 2.91 0 0 1 5.82 0Zm-1.455 0a1.455 1.455 0 1 1-2.91 0 1.455 1.455 0 0 1 2.91 0Z",
    fill: "#bf0a76",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5a8 8 0 1 0 0 16 8 8 0 1 0 0-16Zm-6.545 8c0 1.52.518 2.92 1.387 4.03a6.535 6.535 0 0 1 5.206-2.575 6.534 6.534 0 0 1 5.157 2.515A6.545 6.545 0 1 0 6.455 13ZM13 19.546a6.518 6.518 0 0 1-4.125-1.464 5.085 5.085 0 0 1 4.173-2.173 5.084 5.084 0 0 1 4.137 2.124A6.52 6.52 0 0 1 13 19.546Z",
    fill: "#bf0a76",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileColor);
export default __webpack_public_path__ + "static/media/profile-color.0d25b8402db06228cbe868a9e0be5f0c.svg";
export { ForwardRef as ReactComponent };